import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'lib-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrl: './expansion-panel.component.scss'
})
export class ExpansionPanelComponent {
    isToggled = false;

    @Output() onToggleChanged = new EventEmitter<boolean>();

    switchTogglestate() {
        this.isToggled = !this.isToggled;
        this.emitToggleChange();
    }

    emitToggleChange() {
        this.onToggleChanged.emit(this.isToggled);
    }
}